import { 
  GET_POLYGON_AREAS, 
  GET_POLYGON_AREAS_SUCCESS, 
  GET_POLYGON_AREAS_FAILURE, 
  GET_POLYGON, 
  GET_POLYGON_FAILURE, 
  GET_POLYGON_SUCCESS,
  GET_ALL_POLYGON_METRICS,
  GET_ALL_POLYGON_METRICS_SUCCESS,
  GET_ALL_POLYGON_METRICS_FAILURE
} from './actions';

const initialState = {
  polygonAreas: [],
  loading: false,
  error: null,

  polygon: {},
  polygonLoading: false,
  polygonError: null,

  allPolygonMetrics: [],
  allPolygonMetricsLoading: false,
  allPolygonMetricsError: null,
};

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case GET_POLYGON_AREAS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_POLYGON_AREAS_SUCCESS:
      return {
        ...state,
        polygonAreas: action.payload,
        loading: false,
      };
    case GET_POLYGON_AREAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_POLYGON:
      return {
        ...state,
        polygonLoading: true,
        polygonError: null,
      };
    case GET_POLYGON_SUCCESS:
      return {
        ...state,
        polygon: action.payload,
        polygonLoading: false,
      };
    case GET_POLYGON_FAILURE:
      return {
        ...state,
        polygonLoading: false,
        polygonError: action.payload,
      };
    case GET_ALL_POLYGON_METRICS:
      return {
        ...state,
        allPolygonMetricsLoading: true,
        allPolygonMetricsError: null,
      };
    case GET_ALL_POLYGON_METRICS_SUCCESS:
      return {
        ...state,
        allPolygonMetrics: action.payload,
        allPolygonMetricsLoading: false,
      };
    case GET_ALL_POLYGON_METRICS_FAILURE:
      return {
        ...state,
        allPolygonMetricsLoading: false,
        allPolygonMetricsError: action.payload,
      };
    default:
      return state;
  }
}
